import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { AssetRequistion } from "../entity/asset-requisition.entity";

@Injectable()
@EntityRepository(AssetRequistion)
export class AssetRequistionRepository extends Repository<AssetRequistion>{
    
}